import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_GET_DR_POTENTIAL_DETAIL_API, RQ_GET_DR_POTENTIAL_INFO_API, RQ_GET_DR_POTENTIAL_SUMMARY_API,
  RQ_RESET_DR_POTENTIAL_DETAILS_API,
} from '@app/reactQuery/apis/constants/rqDrPotentialAPIConstants';
import {useQuery} from '@tanstack/react-query';

export const RQUseDrPotentialSummaryData = ({locationId, certificate, signal}) => {
  return rqCreateSearchRequest(
    RQ_GET_DR_POTENTIAL_SUMMARY_API,
    null,
    certificate,
    {locationId : locationId},
    signal,
  );
};

export const RQUseDrPotentialDetailData = ({locationId, certificate, signal}) => {
  return rqCreateSearchRequest(
    RQ_GET_DR_POTENTIAL_DETAIL_API,
    null,
    certificate,
    {locationId : locationId},
    signal,
  );
};

export const RQUseGetDoctorPotentialData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_dr_potential_info_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, doctorUniqueCode} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DR_POTENTIAL_INFO_API,
        null,
        certificate,
        {
          doctorUniqueCode: doctorUniqueCode,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQResetDoctorPotentialDetails = ({doctorId, certificate, signal}) => {
  return rqCreateRequest(
    RQ_RESET_DR_POTENTIAL_DETAILS_API,
    JSON.stringify({doctorId}),
    certificate,
    {doctorId},
    signal,
  );
};
